import pagination from '@iso/lib/helpers/pagination';

const model = {
    ...pagination('marketingList').model,
    submitting: false,
    errors: null,
    success: '',
};

export default model;